import React, { useEffect } from 'react';
import {
  ISearchProduct,
  ISearchVehicle,
  IState,
  Replacement,
} from '../../../interface';
import {connect} from 'react-redux';
import _ from 'lodash';
import Carousels from '../Carousels';
import FilterResult from '../FilterResult';
import {useAppName} from '../../../hooks/use-app-names';
import {ANALYTICS_BUTTON_NAME, ANALYTICS_EVENT, ANALYTICS_PAGE_TYPE, ANALYTICS_SEARCH_TYPE, APPNAME, FASTSCAN} from '../../../constants';
import {useSearchParams} from 'react-router-dom';
import Loading from '../../Loading';
import OilFilterResult from '../OilFilterResult';
import { Dispatch } from 'redux';
import actions from '../../../redux/actions';

import { useAnalytics } from '../../../hooks/use-analytics';

import styles from './index.module.scss';

interface Props {
  onProductSelect: (v: string) => void;
  replacements: Replacement;
  results: ISearchVehicle[] | ISearchProduct[] | null;
  licenseKeys: string;
  loading: boolean;
  setResults: (v: ISearchVehicle[] | ISearchProduct[] | null) => void;
  setLicenseKeys: (v: string) => void;
  setLoading: (v: boolean) => void;
}

function Landing(props: Props) {
  const {onProductSelect, results, replacements, licenseKeys, loading, setResults, setLicenseKeys, setLoading} = props;
  const isFastScan = useAppName(FASTSCAN);
  const [searchParams, setSearchParams] = useSearchParams();
  const sendAnalytics = useAnalytics();
  const onVehicleSelect = (value: string | number, model?: string) => {
    //value=18f847ba17864033e0659fbab47aa869
    sendAnalytics({
      event: ANALYTICS_EVENT.VIEW_RECOMMENDED_OILS_CLICK ,
      page: ANALYTICS_PAGE_TYPE.PRODUCT_FINDER,
      button: ANALYTICS_BUTTON_NAME.VIEW_RECOMMENDED_OILS,
      country: localStorage.getItem('countryCode') || '',
      model: model,
      search:
        localStorage.getItem('searchTab') === ANALYTICS_SEARCH_TYPE.VEHICLE_SEARCH
          ? ANALYTICS_SEARCH_TYPE.VEHICLE_SEARCH
          : ANALYTICS_SEARCH_TYPE.QUICK_SEARCH,
    });
    

    searchParams.set('page', 'recommendedProducts');
    searchParams.set('id', _.toString(value));
    isFastScan && searchParams.set(APPNAME, FASTSCAN);
    setSearchParams(searchParams);
  };
  useEffect(() => {
    return () => {
      setResults(null);
      setLicenseKeys('');
      setLoading(false);
    }
  }, []);
  return !results ? (
    licenseKeys ? (
      <div className='no-match'>
        <div className='no-found-text no-oil-text'>
          <p dangerouslySetInnerHTML={{__html: licenseKeys}}></p>
        </div>
      </div>
    ) : (
      <Carousels />
    )
  ) : loading ? (
    <Loading />
  ) : (
    <div className={`${styles['results-fluid']} results-list`}>
      {_.get(results[0], 'make') ? (
        <FilterResult
          dataList={results as ISearchVehicle[]}
          replacements={replacements}
          onSelect={onVehicleSelect}
        />
      ) : (
        <OilFilterResult
          dataList={results as ISearchProduct[]}
          replacements={replacements}
          onSelect={onProductSelect}
        />
      )}
    </div>
  );
}

const mapStateToProps = (state: IState) => ({
  results: state.results,
  replacements: state.replacements,
  licenseKeys: state.licenseKeys,
  loading: state.loading,
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setResults: (vehicle: ISearchVehicle[] | ISearchProduct[] | null) =>
    dispatch(actions.setResults(vehicle)),
  setLicenseKeys: (v: string) => dispatch(actions.setLicenseKeys(v)),
  setLoading: (v: boolean) => dispatch(actions.setLoading(v)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Landing);
